<template>
  <div class="article-normal-card-component transition-wrapper" :class="size">
    <div class="image-wrapper top">
      <img
        v-lazy="item.thumbnail"
        class="thumbnail"
        :alt="`微博营销 ${item.title}`"
        :title="`微博营销 ${item.title}`"
      />
    </div>
    <div class="info bottom app-flex-column">
      <span class="author" :class="size === 'normal' ? 'font-14' : 'font-12'">
        作者：{{ item.author }}
      </span>
      <span
        class="title"
        :class="[
          size === 'normal' ? 'font-18' : 'font-14',
          { internal: isInternal }
        ]"
      >
        <i v-if="isInternal" class="internal-icon font-12 app-flex-row-center">
          对内
        </i>
        <p>{{ item.title }}</p>
      </span>
      <span v-if="size === 'normal'" class="desc font-14">
        {{ item.description }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    size: {
      /**
       * 大小：
       * normal：
       * width：278px height：197px+140px = 337px
       * info: padding: 14px 24px 40px 24px
       * author: font-size:14px; margin-bottom:12px
       * title: font-size:18px
       * desc: font-size:14px
       * small:
       * width：196px height：139px+108px = 247px
       * info: padding: 12px 12px 24px 12px
       * author: font-size:12px; margin-bottom:8px
       * title: font-size:14px
       * desc: 不显示
       */
      validator(value) {
        return ['small', 'normal'].includes(value)
      },
      default: 'normal'
    }
  },
  computed: {
    isInternal() {
      return this.item.authority == '1'
    }
  }
}
</script>

<style lang="scss" scoped>
.article-normal-card-component {
  @include transitionCard;

  cursor: pointer;
  .image-wrapper {
    width: 100%;

    .thumbnail {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      object-fit: cover;
    }
  }
  .info {
    height: 140px;
    .title {
      @include text-over-flow;
      // margin: 12px 0 14px;
      word-break: break-word;
      &.internal {
        position: relative;
        .internal-icon {
          color: $white;
          background-color: $base-color-3;
          height: 18px;
          width: 40px;
          position: absolute;
          left: 0;
          top: 4px;
          text-indent: 0;
          border-radius: 18px;
        }
        & > p {
          text-indent: 50px;
        }
      }
    }
    .desc {
      @include text-over-flow(3);
      word-break: break-all;
      height: 0;
    }
  }

  &.normal {
    /** 宽：278px 高：197px */
    width: 278px;
    margin-bottom: 30px;
    .image-wrapper {
      height: 197px;
      .thumbnail {
        width: 278px;
        height: 197px;
      }
    }
    .info {
      padding: 14px 24px 0;
      .author {
        margin-bottom: 12px;
      }
    }
    &:hover {
      /**
    图片增加15%黑色遮罩，图片上移32px，图片区域减少76px高
    文字增加76px高度，底色色值#ffffff
     */
      .image-wrapper {
        height: 121px;
        .thumbnail {
          margin-top: -32px;
        }
      }
      .info {
        height: 216px;
        .desc {
          height: auto;
          padding-top: 14px;
          color: $text-color-desc;
        }
        .author {
          margin-bottom: 14px;
        }
      }
    }
  }

  &.small {
    /** 宽：196px 高：247px */
    width: 196px;
    margin-bottom: 24px;
    .image-wrapper {
      width: 196px;
      height: 139px;
      .thumbnail {
        width: 196px;
        height: 139px;
        transition: transform 0.3s;
      }
    }
    .info {
      height: 108px;
      padding: 12px 12px 24px 12px;
      .author {
        margin-bottom: 8px;
      }
    }
    &:hover {
      /** 图片扩大1.05倍 */
      .image-wrapper .thumbnail {
        transform: scale(1.05) translate(-50%, -50%);
      }
    }
  }
}
</style>
